export default __webpack_public_path__ + "static/media/estudios.57d2cd8e.svg";